import { ArrowLeft, FileQuestion } from 'lucide-react'
import { Link } from 'react-router-dom'

import { Button } from '@/components/ui/button'

export function NotFoundPage() {
	return (
		<section className="mx-auto flex min-h-[70vh] w-full max-w-md flex-col items-center justify-center px-4 py-16 text-center">
			<div className="mb-4 flex size-12 items-center justify-center rounded-xl bg-muted text-muted-foreground">
				<FileQuestion className="size-6" />
			</div>
			<h1 className="text-2xl font-semibold tracking-tight">Page not found</h1>
			<p className="mt-2 text-sm text-muted-foreground">
				The page you're looking for doesn't exist or has been moved.
			</p>
			<Button asChild className="mt-6">
				<Link to="/">
					<ArrowLeft className="size-4" />
					Back home
				</Link>
			</Button>
		</section>
	)
}
